import { AlertBar2 } from "@/ui2/atoms/AlertBar";
import type { AlertProps } from "@/ui2/atoms/AlertBar";
import { Button2 } from "@/ui2/atoms/Button";

type Props = Omit<AlertProps, "variant" | "children"> & {
  isAdmin: boolean;
  isSchedulingRestricted: boolean;
  onNavigateToAdmin: () => void;
};

export function SchedulingRestrictedBanner({
  isAdmin,
  isSchedulingRestricted,
  onNavigateToAdmin,
  ...props
}: Props) {
  if (!isSchedulingRestricted) return null;

  const suffix = isAdmin ? (
    <Button2
      className="tw:border-stroke-error-primary tw:bg-transparent tw:text-text-error-primary"
      onPress={onNavigateToAdmin}
      size="xs"
      variant="secondary"
    >
      Change Scheduling Restrictions
    </Button2>
  ) : (
    "To remove this restriction, please contact your supervisor."
  );

  return (
    <AlertBar2 className="tw:flex tw:items-center tw:justify-between" variant="error" {...props}>
      <strong className="tw:mr-ch">Patient Scheduling Restricted.</strong>
      <span className="tw:mr-auto">
        This patient is unable to schedule or reschedule appointments.
      </span>
      {suffix}
    </AlertBar2>
  );
}
